<template>
  <div>
    <audio
      controls="controls"
      hidden
      src="../../../assets/err.mp3"
      ref="erraudio"
    ></audio>
    <audio
      controls="controls"
      hidden
      src="../../../assets/success.wav"
      ref="successaudio"
    ></audio>
    <div class="conventionalBox-info">
      <div>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">进仓单号</van-col>
          <van-col span="12" class="other-cell txt-left">{{
            list.deliveryOrdeNo
          }}</van-col>
          <van-col span="6" class="other-cell">{{ list.customName }}</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">参考单号</van-col>
          <van-col span="12" class="other-cell txt-left">{{
            list.orgCustomerNo
          }}</van-col>
          <van-col span="6" class="other-cell">{{
            list.isTransit ? "中转" : ""
          }}</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">预计到仓</van-col>
          <van-col span="7" class="other-cell">{{
            list.estimatedDateDesc
          }}</van-col>
          <van-col span="5">预报箱数</van-col>
          <van-col span="6" class="other-cell">{{
            list.totalBoxCount
          }}</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">预报重量</van-col>
          <van-col span="7" class="other-cell">{{
            list.totalGrossWeight
          }}</van-col>
          <van-col span="5">预报体积</van-col>
          <van-col span="6" class="other-cell">{{ list.totalVolume }}</van-col>
        </van-row>
        <van-row
          v-if="list.machineBoxCount > 0"
          type="flex"
          justify="center"
          align="center"
        >
          <van-col span="6">过机箱数</van-col>
          <van-col span="10" class="other-cell">{{
            list.machineBoxCount
          }}</van-col>
          <van-col span="8" class="other-cell"
            ><button
              @click="getBoxInfo()"
              class="btn"
              style="
                width: 60%;
                height: 33px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 30px;
              "
            >
              读取设备
            </button></van-col
          >
        </van-row>
      </div>
    </div>

    <div
      v-if="!isMachine"
      class="conventionalBox-info conventionalBox-info_pad"
    >
      <div
        class="signInDetail-btnBox"
        v-for="(item, index) in info1"
        :key="index"
      >
        <ul>
          <li>
            <p class="p-title">{{ item.skuCode }}</p>
          </li>
          <li>
            <span>长</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.boxLength"
              @input="inputLenChange('info1', index, 'boxLength', 2)"
              @change="inputNumChange('info1', index, 'boxLength', 2)"
              placeholder="cm"
              :readonly="item.isTransit"
            />
            <span>宽</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.boxWidth"
              @input="inputLenChange('info1', index, 'boxWidth', 2)"
              @change="inputNumChange('info1', index, 'boxWidth', 2)"
              placeholder="cm"
              :readonly="item.isTransit"
            />
            <span>高</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.boxHeight"
              @input="inputLenChange('info1', index, 'boxHeight', 2)"
              @change="inputNumChange('info1', index, 'boxHeight', 2)"
              placeholder="cm"
              :readonly="item.isTransit"
            />
          </li>
          <li>
            <span>重</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.boxWeight"
              @input="inputLenChange('info1', index, 'boxWeight', 2)"
              @change="inputNumChange('info1', index, 'boxWeight', 2)"
              placeholder="kg"
              :readonly="item.isTransit"
            />
            <span>箱数</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.boxCount"
              @input="inputLenChange('info1', index, 'boxCount', 0)"
              @change="inputNumChange('info1', index, 'boxCount', 0)"
              placeholder=""
              :readonly="item.isTransit"
            />
            <button
              v-if="!item.isTransit"
              class="btn"
              style="float: right"
              @click="toAdd(item.skuCode)"
            >
              加箱规
            </button>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="isMachine" class="conventionalBox-info conventionalBox-info_pad">
      <p class="p-title">测量数据</p>
      <div
        class="signInDetail-btnBox"
        v-for="(item, index) in infoMachine"
        :key="index"
      >
        <ul>
          <li>
            <span>箱数</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.boxCount"
              @input="inputLenChange('infoPallet', index, 'boxCount', 0)"
              @change="inputNumChange('infoPallet', index, 'boxCount', 0)"
              placeholder=""
              readonly="true"
            />
            <span>总重量</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.totalWeight"
              @input="inputLenChange('infoPallet', index, 'totalWeight', 0)"
              @change="inputNumChange('infoPallet', index, 'totalWeight', 0)"
              placeholder=""
              readonly="true"
            />
            <span>总体积</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.totalVolumn"
              @input="inputLenChange('infoPallet', index, 'totalVolumn', 0)"
              @change="inputNumChange('infoPallet', index, 'totalVolumn', 0)"
              placeholder=""
              readonly="true"
            />
          </li>
        </ul>
      </div>
    </div>
    <div class="conventionalBox-info conventionalBox-info_pad">
      <p class="p-title">卡板信息</p>
      <div
        class="signInDetail-btnBox"
        v-for="(item, index) in infoPallet"
        :key="index"
      >
        <ul>
          <li>
            <span>托盘</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.palletQty"
              @input="inputLenChange('infoPallet', index, 'palletQty', 0)"
              @change="inputNumChange('infoPallet', index, 'palletQty', 0)"
              placeholder=""
            />
            <span>X箱数</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.boxQty"
              @input="inputLenChange('infoPallet', index, 'boxQty', 0)"
              @change="inputNumChange('infoPallet', index, 'boxQty', 0)"
              placeholder=""
            />
            <span>尾托箱</span>
            <input
              type="number"
              class="volume fl"
              v-model="item.tailBoxQty"
              @input="inputLenChange('infoPallet', index, 'tailBoxQty', 0)"
              @change="inputNumChange('infoPallet', index, 'tailBoxQty', 0)"
              placeholder=""
            />
            <button class="btn" style="float: right" @click="toAddPallet()">
              加托盘
            </button>
          </li>
        </ul>
      </div>
    </div>
    <div class="conventionalBox-info_pad">
      <div class="photo">
        <p class="p-title" style="margin-top: 10px">收货照片</p>
        <div class="sign-photo-cpntent">
          <div class="sign-photo-box">
            <ul>
              <li
                class="sign-photo-item"
                v-for="(item, index) in skuImg"
                :key="index"
              >
                <span class="delete-icon" @click="deleteImg(index)">x</span>
                <!-- <van-icon name="photo" size="6em" color="#169bd5"/> -->
                <img
                  :src="item"
                  class="sign-photo-item-img"
                  alt=""
                  @click="previewImage(item)"
                />
              </li>

              <li class="sign-photo-btn">
                <div class="photo">
                  <input
                    class="img hidden receive"
                    @change="changeImg()"
                    type="file"
                    name="cover"
                    ref="inputer"
                    accept="image/*"
                    multiple
                  />
                  <p @click="chooseImage">
                    <i class="el-icon-camera"></i>
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div class="signInDetail-end">
            <span class="">支付方:{{ this.list.unloadingPayer }}</span>
            <van-radio-group v-model="list.isUnloadFlag" direction="horizontal">
              <van-radio shape="square" name="unload">货主自卸</van-radio>
              <van-radio shape="square" name="isUnload">仓库卸货</van-radio>
            </van-radio-group>
          </div>
          <div class="signInDetail-end">
            <van-field
              v-model="remark"
              style="margin-left: 10px"
              rows="2"
              autosize
              type="textarea"
              maxlength="200"
              placeholder="备注信息"
              show-word-limit
            />
          </div>
          <div style="font-size: 15px; padding: 0 2px">
            <span class="">收货统计 {{ this.list.actualBoxCount }}箱</span>

            <el-button
              v-if="!list.isTransit"
              type="success"
              size="small"
              @click="printInfo"
              style="
                float: right;
                margin-right: 1px;
                margin-top: -5px;
                border-radius: 5px;
              "
              >打印托唛</el-button
            >
            <van-checkbox
              v-model="isAbnormal"
              shape="square"
              style="float: right; margin-right: 10px"
              >收货异常</van-checkbox
            >
          </div>
          <div v-if="isAbnormal">
            <div class="yichang">
              <p class="p-title">异常说明</p>
              <van-field
                size="small"
                v-model="abnormalRemark"
                placeholder="异常说明"
              />
            </div>
            <p class="p-title">异常照片</p>
            <div class="sign-photo-box">
              <ul>
                <li
                  class="sign-photo-item"
                  v-for="(item, index) in skuImgAbnor"
                  :key="index"
                >
                  <span class="delete-icon" @click="deleteImgAbnor(index)"
                    >x</span
                  >
                  <!-- <van-icon name="photo" size="6em" color="#169bd5"/> -->
                  <img
                    :src="item"
                    class="sign-photo-item-img"
                    alt=""
                    @click="previewImage(item)"
                  />
                </li>

                <li class="sign-photo-btn">
                  <div class="photo">
                    <input
                      class="img hidden abnor"
                      @change="changeImgAbnor()"
                      type="file"
                      name="cover"
                      ref="inputer"
                      accept="image/*"
                      multiple
                    />
                    <p @click="chooseImageAbnor">
                      <i class="el-icon-camera"></i>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="sign-photo-save">
            <button
              class="submit-btn"
              :disabled="isButtonDisabled"
              @click="submit"
            >
              保存
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
  SwipeCell,
  Col,
  Row,
  Button,
  Cell,
  Dialog,
  CheckboxGroup,
  RadioGroup,
  Radio,
} from "vant";
import {
  GetRecheckDetailForBale,
  AddCheckforArkAsync,
} from "@/api/mobile/recheck_api";
import { PrintPallet } from "@/api/mobile/bale_api.js";
import { mixins } from "../mobileMixins";
import { mapMutations } from "vuex";
import axios from "axios";
import { BaseApiUrl } from "@/api/axios_config";
import { GetPrinterByUser, AddUserPrinter } from "@/api/mobile/common_api";
import {
  getDeliveryNo,
  submitSignForAndReceive,
  getDeliveryPreBox,
  getDeliveryMachineBox,
} from "@/api/mobile/jy-signReceipt_api";
export default {
  data() {
    return {
      list: {},
      info1: {},
      infoPallet: {},
      infoMachine: {},
      skuImg: [],
      skuImgAbnor: [],
      isAbnormal: false,
      isMachine: false,
      isButtonDisabled: false,
      remark: "",
      tfsignID: 0,
      abnormalRemark: "",
      saveImgUrlArr: [],
      saveImgUrlArrAbnor: [],
      imgFiles: [],
      imgFilesAbnor: [],
      isSetPrinter: false,
      actionsForPrint: [],
      showActionSheetForPrint: false,
      list: {
        actualArriveDate: this.getToday(),
      },
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [SwipeCell.name]: SwipeCell,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
    [CheckboxGroup.name]: CheckboxGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
  },
  mixins: [mixins],
  created() {
    this.init();
  },
  methods: {
    ...mapMutations({}),
    deleteImg(i) {
      this.skuImg.splice(i, 1);
      this.saveImgUrlArr.splice(i, 1);
    },
    deleteImgAbnor(i) {
      this.skuImgAbnor.splice(i, 1);
      this.saveImgUrlArrAbnor.splice(i, 1);
    },

    toAdd(skuCode) {
      this.info1.push({
        skuCode: skuCode,
        boxWeight: "",
        boxHeight: "",
        boxWidth: "",
        boxLength: "",
        boxCount: "",
      });

      this.info1.sort((a, b) => a.skuCode.localeCompare(b.skuCode));
    },

    toAddPallet() {
      this.infoPallet.push({
        tailBoxQty: "",
        boxQty: "",
        palletQty: "",
      });
    },

    changeImg() {
      const img = document.getElementsByClassName("receive")[0];
      let imgList = [...img.files];

      this.imgFiles.push(...imgList);

      this.handleFiles(imgList);

      this.submitImg();
    },

    changeImgAbnor() {
      const img = document.getElementsByClassName("abnor")[0];
      let imgList = [...img.files];

      this.imgFilesAbnor.push(...imgList);

      this.handleFilesAbnor(imgList);

      this.submitImgAbnor();
    },

    chooseImage() {
      document.getElementsByClassName("receive")[0].click();
    },
    chooseImageAbnor() {
      document.getElementsByClassName("abnor")[0].click();
    },

    // 预览图片
    previewImage(url) {
      ImagePreview({
        images: [url],
        closeable: true,
      });
    },

    handleFiles(files) {
      const that = this;
      let srcArr = []; // 保存转换的base64 imgFileUrl

      for (var i = 0; i < files.length; i++) {
        var file = files[i];

        const { type, name } = file;

        var imageType = /^image\//;
        if (!imageType.test(type)) {
          continue;
        }

        var reader = new FileReader();
        reader.onload = function (e) {
          that.$set(that.skuImg, that.skuImg.length, e.target.result);
        };
        reader.readAsDataURL(file);
      }
    },

    handleFilesAbnor(files) {
      const that = this;
      let srcArr = []; // 保存转换的base64 imgFileUrl

      for (var i = 0; i < files.length; i++) {
        var file = files[i];

        const { type, name } = file;

        var imageType = /^image\//;
        if (!imageType.test(type)) {
          continue;
        }

        var reader = new FileReader();
        reader.onload = function (e) {
          that.$set(that.skuImgAbnor, that.skuImgAbnor.length, e.target.result);
        };
        reader.readAsDataURL(file);
      }
    },

    submitImg() {
      const that = this;

      let formDatas = new FormData();

      this.imgFiles.forEach((i, index) => {
        formDatas.append("files", i);
      });

      Toast.loading({
        message: "保存中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      axios({
        url: `${BaseApiUrl}/Img/InsertFtpImage`,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        Toast.clear();
        if (res.data.status === 200 && res.data.success) {
          this.saveImgUrlArr.push(...res.data.response);
          this.imgFiles = [];
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },

    submitImgAbnor() {
      const that = this;

      let formDatas = new FormData();

      this.imgFilesAbnor.forEach((i, index) => {
        formDatas.append("files", i);
      });

      Toast.loading({
        message: "保存中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      axios({
        url: `${BaseApiUrl}/Img/InsertFtpImage`,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        Toast.clear();
        if (res.data.status === 200 && res.data.success) {
          this.saveImgUrlArrAbnor.push(...res.data.response);
          this.imgFilesAbnor = [];
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    inputLenChange(name, i, field, fix = 1) {
      let s = this[name][i][field];
      if (s.includes(".")) {
        const m = s.split(".")[0];
        if (m.length > 3) {
          this.$set(this[name][i], field, Number(`${m.slice(0, 3)}.${m[1]}`));
        }
      } else {
        if (s.length > 4) {
          this.$set(this[name][i], field, this[name][i][field].slice(0, 4));
        }
      }
    },
    inputNumChange(name, i, field, fix = 1) {
      function toF(n, fix) {
        return Number(n).toFixed(fix);
      }

      let s = this[name][i][field];

      let num = toF(s, fix);
      if (num < 0) {
        Toast("请输入正数");
        num = toF(0, fix);
      }

      this.$set(this[name][i], field, num);
      if (
        field === "palletQty" ||
        field === "boxQty" ||
        field === "tailBoxQty"
      ) {
        let totalBoxCount = 0;
        this.infoPallet.map((item) => {
          if (parseInt(item.palletQty) > 0 && parseInt(item.boxQty) > 0) {
            totalBoxCount += parseInt(item.palletQty) * parseInt(item.boxQty);
          }
          if (parseInt(item.tailBoxQty) > 0) {
            totalBoxCount += parseInt(item.tailBoxQty);
          }
        });
        this.$set(this.list, "actualBoxCount", totalBoxCount);
      }
    },
    inputParseIntNumChange(name, i, field) {
      let num = Number(this[name][i][field]);
      if (num < 0) {
        Toast("请输入正整数");
        num = Math.abs(num);
      }
      this.$set(this[name][i], field, parseInt(num));

      // if (name === "info1" && field === "boxCount") {
      //   if (String(this.info1[i].boxCount).length > 10)
      //     this.$set(
      //       this.info1[i],
      //       "boxCount",
      //       Number(String(this.info1[i].boxCount).slice(0, 10))
      //     );
      // }
    },
    getToday() {
      var currentDate = new Date();
      var year = currentDate.getFullYear();
      var month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
      var day = ("0" + currentDate.getDate()).slice(-2);
      var hours = ("0" + currentDate.getHours()).slice(-2);
      var minutes = ("0" + currentDate.getMinutes()).slice(-2);

      var formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
      return formattedDate;
    },
    init() {
      this.getDeliveryNo();
    },
    getDeliveryNo() {
      const { deliveryOrdeNo } = this.$route.query;
      const data = {
        deliveryOrdeNo,
      };

      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      getDeliveryNo(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          const { response } = res;
          const { signBoxList, pattleList } = res.response;
          this.info1 = signBoxList;
          this.infoPallet = pattleList;
          this.list = {
            ...response,
            actualArriveDate: this.getToday(),
          };
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    printInfo() {
      // let totalBoxCount = this.info1.reduce((sum, item) => {
      //   return sum + item.boxCount;
      // }, 0);
      let { warehouseID } = this.list;
      // if (totalBoxCount != actualBoxCount) {
      //   Toast("请维护箱数正确");
      //   return;
      // }
      if (this.tfsignID == 0) {
        Toast("请先保存签收再打印");
        return;
      }

      this.toGetPrinterByUser(warehouseID);
    },
    // 查询用户是否设置打印机123
    toGetPrinterByUser(warehouseID) {
      const data = {
        moduleType: 10, // 箱唛
        wareId: warehouseID,
      };
      this.isSetPrinter = false;
      this.actionsForPrint = [];

      GetPrinterByUser(data).then((res) => {
        const { status, response, msg } = res;
        console.info(status);
        console.info(response);
        console.info(msg);
        if (status === 200 && response.length) {
          this.showActionSheetForPrint = true;
          Toast("请选择打印机");
          response.forEach((item, i) => {
            this.actionsForPrint.push({
              name: item.printerName,
              id: item.printerInfoID,
            });
            console.log(this.actionsForPrint);
          });
        } else if (status === -100) {
          Toast(msg);
        }
        if (status === 200 && response === 0) {
          this.isSetPrinter = true;
          this.printpalletinfo();
        }
      });
      console.log("显示打印机" + this.isSetPrinter);
    },
    printpalletinfo() {
      this.printSuccess = false;
      const data = {
        sourceID: this.tfsignID,
        sourceType: 45,
        wareID: this.list.warehouseID,
      };
      console.info(data);
      PrintPallet(data).then((res) => {
        Toast.clear();
        if (res.success) {
          this.jsonpPrint(res.response);
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    jsonpPrint(url) {
      Toast.loading({
        message: "打印中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });

      //  console.log('打印机地址是:'+url);

      this.$http
        .jsonp(url)
        .then((res) => {
          console.log("success", res.body.s); //请求成功
          Toast.clear();
          Toast.success("打印成功");
          // 更新状态
          this.printSuccess = true;
        })
        .catch((err) => {
          Toast.fail("打印失败");
          console.log("err", err); //请求失败
          Toast.clear();
          if (err.status === 0 || err.status === 500) {
            // 更新状态    打印机有时会跑到err事件里,暂时这样处理
            this.printSuccess = true;
            Toast.success("打印成功");
          } else {
            Toast.fail("打印失败");
          }
        });
    },
    getBoxInfo() {
      const { deliveryOrdeNo } = this.$route.query;
      const data = {
        deliveryOrdeNo,
      };

      Toast.loading({
        message: "读取中...",
        forbidClick: true,
      });
      getDeliveryMachineBox(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          const { signBoxList } = res.response;
          if (signBoxList.length > 0) {
            this.infoMachine = signBoxList;
            this.isMachine = true;
            this.$set(this.list, "actualBoxCount", signBoxList[0].boxCount);
            this.showsound(true);
            Toast.success("查询成功,请核对箱数");
          } else {
            Toast.fail("查询不到设备数据,请确认");
          }
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    showsound(isSuccess) {
      if (isSuccess) {
        this.$refs.successaudio.currentTime = 0;
        this.$refs.successaudio.play();
      } else {
        this.$refs.erraudio.currentTime = 0;
        this.$refs.erraudio.play();
      }
    },
    submit() {
      const that = this;
      if (!this.list.isUnloadFlag) {
        this.showsound(false);
        Toast("请选择卸货方式");
        return;
      }
      let receiptBoxList = this.info1.map((item) => {
        return {
          boxWeight: item.boxWeight,
          boxLength: item.boxLength,
          boxWidth: item.boxWidth,
          boxHeight: item.boxHeight,
          skuCode: item.skuCode,
          boxCount: item.boxCount,
        };
      });
      if (!this.isMachine) {
        let totalVolume = receiptBoxList.reduce((acc, box) => {
          return (
            acc + box.boxLength * box.boxWidth * box.boxHeight * box.boxCount
          );
        }, 0);

        totalVolume /= 1000000; // 转换为立方米
        console.info(totalVolume);
        // 计算差异百分比
        const difference =
          Math.abs(
            (totalVolume - this.list.totalVolume) / this.list.totalVolume
          ) * 100;
        // 如果差异超过5%
        if (difference > 5) {
          this.showsound(false);
          Dialog.confirm({
            title: "异常",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            message: `实测与预报体积差异超过5%，确定？`,
          })
            .then(() => {
              let pattleList = this.infoPallet.map((item) => {
          return {
            palletQty: item.palletQty,
            boxQty: item.boxQty,
            tailBoxQty: item.tailBoxQty,
          };
        });
        let {
          tfDeliveryOrderID,
          actualBoxCount,
          actualArriveDate,
          isUnloadFlag,
        } = this.list;
        console.info(this.isMachine);
        const data = {
          isUnload: isUnloadFlag === "isUnload",
          isSyc: this.isMachine,
          tfDeliveryOrderID,
          actualBoxCount,
          actualArriveDate,
          remark: that.remark,
          receiptBoxList: receiptBoxList,
          pattleList: pattleList,
          imageUrls: this.saveImgUrlArr,
          isAbnormal: that.isAbnormal,
          abnormalRemark: that.abnormalRemark,
          imageUrlsAbnor: this.saveImgUrlArrAbnor,
        };

        Toast.loading({
          message: "收货中...",
          forbidClick: true,
        });

        submitSignForAndReceive(data).then((res) => {
          Toast.clear();

          if (res.status === 200) {
            this.showsound(true);
            this.tfsignID = res.response;
            Toast.success("收货成功");
            this.isButtonDisabled = true;
            // setTimeout(function () {
            //   that.$router.go(-1);
            // }, 1500);
          } else {
            this.showsound(false);
            Toast.fail(res.msg);
          }
        });
            })
            .catch(() => {
            });
        }
        else
        {
          let pattleList = this.infoPallet.map((item) => {
          return {
            palletQty: item.palletQty,
            boxQty: item.boxQty,
            tailBoxQty: item.tailBoxQty,
          };
        });
        let {
          tfDeliveryOrderID,
          actualBoxCount,
          actualArriveDate,
          isUnloadFlag,
        } = this.list;
        console.info(this.isMachine);
        const data = {
          isUnload: isUnloadFlag === "isUnload",
          isSyc: this.isMachine,
          tfDeliveryOrderID,
          actualBoxCount,
          actualArriveDate,
          remark: that.remark,
          receiptBoxList: receiptBoxList,
          pattleList: pattleList,
          imageUrls: this.saveImgUrlArr,
          isAbnormal: that.isAbnormal,
          abnormalRemark: that.abnormalRemark,
          imageUrlsAbnor: this.saveImgUrlArrAbnor,
        };

        Toast.loading({
          message: "收货中...",
          forbidClick: true,
        });

        submitSignForAndReceive(data).then((res) => {
          Toast.clear();

          if (res.status === 200) {
            this.showsound(true);
            this.tfsignID = res.response;
            Toast.success("收货成功");
            this.isButtonDisabled = true;
            // setTimeout(function () {
            //   that.$router.go(-1);
            // }, 1500);
          } else {
            this.showsound(false);
            Toast.fail(res.msg);
          }
        });
        }
      }
      else
      {
      let pattleList = this.infoPallet.map((item) => {
          return {
            palletQty: item.palletQty,
            boxQty: item.boxQty,
            tailBoxQty: item.tailBoxQty,
          };
        });
        let {
          tfDeliveryOrderID,
          actualBoxCount,
          actualArriveDate,
          isUnloadFlag,
        } = this.list;
        console.info(this.isMachine);
        const data = {
          isUnload: isUnloadFlag === "isUnload",
          isSyc: this.isMachine,
          tfDeliveryOrderID,
          actualBoxCount,
          actualArriveDate,
          remark: that.remark,
          receiptBoxList: receiptBoxList,
          pattleList: pattleList,
          imageUrls: this.saveImgUrlArr,
          isAbnormal: that.isAbnormal,
          abnormalRemark: that.abnormalRemark,
          imageUrlsAbnor: this.saveImgUrlArrAbnor,
        };

        Toast.loading({
          message: "收货中...",
          forbidClick: true,
        });

        submitSignForAndReceive(data).then((res) => {
          Toast.clear();

          if (res.status === 200) {
            this.showsound(true);
            this.tfsignID = res.response;
            Toast.success("收货成功");
            this.isButtonDisabled = true;
            // setTimeout(function () {
            //   that.$router.go(-1);
            // }, 1500);
          } else {
            this.showsound(false);
            Toast.fail(res.msg);
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";
.item-info {
  padding: 10px;
  font-size: 14px;
  background-color: #f2f2f2;
  .item-ul {
    padding-left: 18.5%;
    .item-li {
      display: flex;
      align-content: flex-start;
      word-break: break-all;
      margin-bottom: 4px;
      padding-bottom: 4px;
      & > div {
        flex: 1;
        line-height: 25px;
        max-width: 100%;
        display: flex;
        & > span {
          vertical-align: text-top;
          &:first-child {
            text-align: start;
            padding-right: 10px;
            display: inline-block;
          }
          &:last-child {
            color: #3d5064;
          }
        }
        & > p {
          line-height: 20px;
          vertical-align: middle;
          color: #3d5064;
          margin: 0;
        }
      }
    }
  }
}
.sign-photo-box {
  margin: 5px 10px 10px;
  box-sizing: border-box;
  padding: 10px;

  ul {
    .sign-photo-item {
      width: 30.333%;
      height: 100px;
      border: 5px solid #ccc;
      box-sizing: border-box;
      position: relative;
      float: left;
      margin: 0 4.5% 4.5% 0;
      line-height: 127px;
      overflow: hidden;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .delete-icon {
        position: absolute;
        background: red;
        color: #fff;
        width: 16px;
        height: 16px;
        top: 0px;
        right: 0px;
        line-height: 16px;
        font-size: 12px;
        border-radius: 16px;
        text-align: center;
      }

      .sign-photo-item-img {
        width: auto;
        height: 100%;
      }
    }

    .sign-photo-btn {
      display: inline-block;
      vertical-align: top;
      width: 30.333%;

      .photo {
        height: 100px;
        position: relative;
        height: 100px;
        background-color: #faf9fc;
        position: relative;
        box-shadow: 0px 0px 7px -1px #cccccc;

        p {
          border: 1px dashed #ccc;
          padding: 10px;
          width: 50px;
          height: 50px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0;

          i {
            font-size: 40px;
            color: #ccc;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}
.signInDetail-end {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 10px;
  font-size: 15px;
}
@media (max-width: 450px) {
  .item-info {
    font-size: 12px;
    .item-ul {
      padding: 0 2%;
      .item-li {
        .item-right {
          margin-left: 3%;
        }
        & > div {
          line-height: 22px;
          & > span {
            &:first-child {
              padding-right: 6px;
            }
            &:last-child {
              flex: 1;
            }
          }
        }
      }
    }
  }
}
.conventionalBox-info {
  font-size: 14px;
  border-bottom: 1px solid #cccccc;
}

.conventionalBox-info_pad {
  padding: 0 15px;
  border-bottom: none;
  .signInDetail-btnBox {
    border-bottom: none;
  }
  .signInDetail-btnBox,
  .volume {
    background: transparent;
    background-color: transparent !important;
  }
}
.sign-photo-save {
  margin-top: 10px;
}
.submit-btn {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 18px;
  border: 0;
}
.signInDetail-btnBox {
  background-color: #fbf9fe;
  border-bottom: 1px solid #cccccc;
  li {
    white-space: nowrap;
    display: flex;
    align-items: baseline;
  }
  .volume {
    min-width: 10%;
    max-width: 27%;
    height: 22px;
    line-height: 22px;
    font-size: 12px;
    border: 0;
    background-color: #fbf9fe;
    border-bottom: 1px solid #757474;
    outline: none;
    margin: 0 5px;
    padding: 0 5px;
    box-sizing: border-box;
  }
  &:last-child {
    border-bottom: 0;
  }
}
.hidden {
  display: none;
}
.addInfo {
  position: absolute;
  right: 1%;
  color: #027db4;
}
.p-title {
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 14px;
}
::v-deep .van-col {
  text-align: center;
  background-color: #f2f2f2;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  border-right: 1px solid #cccccc;
  border-top: 1px solid #cccccc;
  // border-bottom: 1px solid #cccccc;
  &:last-child {
    border-right: 0;
  }
}
.other-cell {
  background-color: #fff !important;
}
.txt-left {
  padding-left: 10px;
  text-align: left !important;
}
.btn {
  width: 20%;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  border: 0;
  margin-top: 4px;
}
.btnPrint {
  width: 20%;
  border-radius: 5px;
  background-color: #7c2ddd;
  color: #fff;
  font-size: 12px;
  height: 30px;
  border: 0;
  margin-top: 4px;
}
.submit-box {
  position: static;
  padding: 20px 0;
  .submit-btn {
    margin-bottom: 10px;
    &:last-child {
      background-color: #ccc;
    }
  }
}
</style>